import { atom } from 'jotai';

export const isDraggingAtom = atom(false);
